module.exports = __webpack_public_path__ + "img/edit-01.94050123.svg";